import { AppBar, Toolbar, Box, Typography, Avatar, Badge, Select, MenuItem, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useEffect, useState, useContext } from "react";
import { GlobalMenuOptions, PostSeasonModuleOptions,InSeasonModuleOptions } from "../utils/menu";
import { green60, white } from "../colors"
import { useNavigate } from "react-router-dom"
import useGetCurrentUser from "../api/useGetCurrentUser"
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { GlobalStateContext, useGlobalState } from "../contexts/GlobalState";
import { useLocation } from 'react-router-dom'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { useCommonStyles } from '../styles/GenericStyle';
import FormControl from '@mui/material/FormControl';
import { GenericConstant } from '../utils/GenericConstant';
import type { AplSiteModel } from "../api/vegApl";
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import DrawerMenu from './common/DrawerMenu';
import { useTheme } from '@mui/material/styles';
import s2sLogo from '../assets/s2sLogo.svg';
interface TopBarProps {
  userName?: string;
  onMenuClick?: () => void;
}

interface MenuItem {
  [key: string]: string | number | undefined;
}

const TopBar = ({ }: TopBarProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const classes = useCommonStyles();
  const { state: globalState, dispatch: globalStateDispatch, sites, setSelectedGlobalSite, setSelectedGlobalRole, setHomePage } = useGlobalState();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const { data: user } = useGetCurrentUser(globalState?.userId || '');
  const { pathname } = useLocation();
  const normalizedPathname = pathname.replace(/^\/veg/, '') || '/';
  const isShowSiteDropModName = normalizedPathname !== '/';
  const isTechnicianRoute = normalizedPathname.startsWith('/technician');
  const isProcessingWorkflowRoute = normalizedPathname.startsWith('/processing-workflow');
  // On mobile resolution TechnicianView is rendered in-place without a URL change,
  // so treat mobile as handheld mode to keep the header consistent.
  const isHandheldRoute = isTechnicianRoute || isProcessingWorkflowRoute || isMobile;
  const [siteSelected, setSiteSelected] = useState("");
  const [userOwnSites, setUserOwnSites] = useState<AplSiteModel[]>([]);
  const { state } = useContext(GlobalStateContext);
  const collpase = true;
  const [globalRole, setRoleState] = useState("");
  const [moduleName, setModuleName] = useState("");
  // Check if user is in post-season module (splot page or related pages)

  const [menuListArr, setMenuArr] = useState([]);
  const location = useLocation();
  const showSiteAndModule = isShowSiteDropModName && !isHandheldRoute && !['/userManagement', '/help-support', '/contact-info', '/feedback'].includes(normalizedPathname);


  useEffect(() => {

    const ids = new Set(user?.siteNames);    
    const result: any = sites.filter((item: any) => ids.has(item.site_code)); 
    setUserOwnSites(result);
    const storedSite = localStorage.getItem("siteSelection");
    let resolvedSite = storedSite ?? result?.[0]?.full_code ?? '';
    // Once allocations are known, a stored site the user no longer has must be dropped —
    // otherwise the dropdown renders blank while data keeps loading for the old site.
    if (result?.length) {
      const isStoredSiteAllowed = result.some((site: any) => site?.full_code === storedSite);
      if (!isStoredSiteAllowed) {
        resolvedSite = result[0]?.full_code ?? '';
        localStorage.setItem("siteSelection", resolvedSite);
      }
    }
    setSiteSelected(resolvedSite);
    setSelectedGlobalSite(resolvedSite);

    globalStateDispatch({
      type: "set_loggin_user_detail",
      data: {
        is_admin_user: user?.is_user_admin ?? false,
        is_tech_user: user?.isTechnician ?? false,
        allocatedSites: result ?? [],
        user_id_db: user?.user_id
      },
    }),
      setSelectedGlobalRole(user?.userRoles?.[0] ?? "");
    setRoleState(user?.userRoles?.[0] ?? "");

    


  }, [user, sites.length])


  useEffect(() => {


    let menuArr: any = [];
    let filterModule: any = [];
    let currentModuleName="";
    if(GenericConstant.POSTSEASONMODULE.includes(normalizedPathname)) {
           currentModuleName="Post-season Processing";
    }
      else if(GenericConstant.INSEASONMODULE.includes(normalizedPathname)){
          currentModuleName="In-season operations";
    }

    setModuleName(currentModuleName);



    if (currentModuleName=="Post-season Processing") {
      filterModule = PostSeasonModuleOptions.filter(menuItem => {
        const role = state?.roleSelected;
        const userRoles = (user?.userRoles || []).map((r: string) => (r || '').trim());
        const menuRoleConfig: Record<string, string[]> = {
          "Configure Workflow": ["S2S-Lead", "Admin"],
          "Label Template": ["S2S-Lead", "Breeder"],
          "MINT Registration": ["S2S-Lead", "Admin", "Technician"],
          "Archived Data": ["S2S-Lead", "Admin", "Breeder"],
        };
        const allowedRoles = menuRoleConfig[menuItem.menuName];
        if (!allowedRoles) return true;

        if (menuItem.menuName === "Label Template") {
          return userRoles.some((userRole: string) => allowedRoles.includes(userRole));
        }
        return allowedRoles.includes(role);
      })

    }

    menuArr['postSeason'] = filterModule;
    menuArr['general'] = GlobalMenuOptions;

    setMenuArr((prev) => ({
      ...prev, ...menuArr
    }));

    setMenuArr(menuArr);


  }, [user, state?.roleSelected, normalizedPathname])


  const setSelectedSite = (val: any) => {
    localStorage.setItem("siteSelection",val);
    setSiteSelected(val);
    setSelectedGlobalSite(val);
  }


  const handleDrawerClose = () => {
    setOpen(false);
  }
  


  const setGlobalRole = (roleVal: string) => {
    setSelectedGlobalRole(roleVal);
    setRoleState(roleVal);
    if(!["Admin","Breeder"].includes(roleVal) && location.pathname.includes("harvest-req")  ){
          navigate("/");
    }




  }





  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        sx={{
          bgcolor: 'white',
          color: 'black',
          boxShadow: '0px 2px 4px 0px #00000040',
          position: 'relative',
          zIndex: (theme) => theme.zIndex.appBar,
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 1.5, sm: 2 }, py: { xs: 1, sm: 0.75 }, minHeight: { xs: 64, sm: 72 }, gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 1, sm: 1.5 }, minWidth: 0, flex: 1 }}>
            {isMobile && isHandheldRoute && (
              <img
                src="icons/home_icon.png"
                alt="Home"
                style={{ width: 22, height: 22, cursor: 'pointer' }}
                onClick={() => {
                  setHomePage(true);
                  navigate('/technician');
                }}
              />
            )}

            {!isHandheldRoute && (
              <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate('')}>
                <Box
                  component="img"
                  src={s2sLogo}
                  alt="S2S DIGI"
                  sx={{
                    height: { xs: 28, sm: 36, md: 42 },
                    width: 'auto',
                    objectFit: 'contain',
                  }}
                />
              </Box>
            )}

            {showSiteAndModule && !isMobile && (
              <>
                <Box component="span" className={classes.labelNoto16Bold600} sx={{ backgroundColor: '#DCF8D8', color: '#424242', borderRadius: 2, px: 1, height: 32, display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                  {moduleName}
                </Box>
                <Select
                  sx={{
                    height: 32,
                    width: { md: 168, lg: 192 },
                    borderRadius: 2,
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#00AC4F',
                      borderWidth: 2
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#00AC4F'
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#00AC4F'
                    },
                    '& .MuiSelect-select': {
                      ...GenericConstant.DROPDOWNSTYLE
                    },
                  }}
                  IconComponent={KeyboardArrowDownOutlinedIcon}
                  value={siteSelected ?? ''}
                  onChange={(e) => setSelectedSite(e?.target?.value ?? '')}
                >
                  {userOwnSites?.map((site: any) => (
                    <MenuItem sx={{ ...GenericConstant.DROPDOWNSTYLE }} key={String(site?.full_code ?? '')} value={site?.full_code ?? ''}>
                      {site?.site_name}-{site?.full_code}
                    </MenuItem>
                  ))}
                </Select>
              </>
            )}
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.5, sm: 1 }, flexShrink: 0 }}>
            {false && <Badge
              badgeContent="7"
              overlap="circular"
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
              sx={{
                '& .MuiBadge-badge': {
                  fontSize: 10,
                  fontWeight: 600,
                  color: white,
                  backgroundColor: green60,
                },
                marginRight: '20px',
              }}>

              <Avatar sx={{ width: 40, height: 40, bgcolor: '#DCF8D8', border: `1px solid ${green60}` }}>
                <NotificationsNoneIcon sx={{ color: green60 }}></NotificationsNoneIcon>
              </Avatar>
            </Badge>}
            {!isMobile ? <Avatar sx={{ width: 40, height: 40, bgcolor: '#757575' }}>
            </Avatar>
              : <Avatar sx={{
                width: 36,
                height: 36,
                borderRadius: '20px',
                color: green60,
                bgcolor: "#CEFFDD",
                border: "0.5px solid #00AC4F",
                pt: '6px',
                pr: '8px',
                pb: '6px',
                pl: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <Typography className={classes.labelNoto16Bold500}>
                  {user?.user_name ? user.user_name.substring(0, 2).toUpperCase() : ""}
                </Typography>
              </Avatar>}

            {!isMobile && !isTablet && user?.userRoles?.length > 0 && (
              <Box sx={{ minWidth: 120, display: "flex", flexDirection: "column" }}>
                <Typography variant="body2" sx={{ mr: 1 }}>
                  {user?.user_name ?? ""}
                </Typography>
                <Box sx={{ minWidth: 120 }}>
                  {user?.userRoles.length == 1 ?
                    <Typography color={"#404040"} className={classes.labelNoto12Bold400} sx={{ mr: 1 }}>
                      {user?.userRoles[0] ?? ""}
                    </Typography>

                    : <FormControl fullWidth>

                      <Select sx={{
                        height: 25, width: 160,
                        '& .MuiOutlinedInput-notchedOutline': {
                          border: "none"
                        },

                        "& .MuiInputBase-input": {
                          padding: 0
                        },

                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: "#00AC4F"
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: "#00AC4F"
                        },
                        '& .MuiSelect-select': {
                          ...GenericConstant.DROPDOWNSTYLE
                        },

                      }} IconComponent={KeyboardArrowDownOutlinedIcon} value={globalRole ?? ""} onChange={(e) => setGlobalRole(e?.target?.value ?? "")}>

                        {user?.userRoles?.map((role: any) => (
                          <MenuItem className={classes.labelNoto12Bold400} key={String(role)} value={role ?? ""}>
                            {role}</MenuItem>
                        ))}
                      </Select>                    
                    </FormControl>
                  }
                </Box>

              </Box>
            )}

            {!isHandheldRoute && <IconButton
                disableFocusRipple
                sx={{
                  ...(open
                    ? {
                      width: 40,
                      height: 40,
                      borderRadius: "8px",
                      borderWidth: "1px",
                      border: "1px solid #8E8E8E",
                      padding: "4px",
                      gap: "10px",
                      background: "#fff",
                      opacity: 1,
                    }
                    : {}),
                  "&:focus": { outline: "none" },
                  "&.Mui-focusVisible, &:focus-visible": {
                    outline: "none",
                    boxShadow: "none",
                  },
                }}
                edge="end"
                color="inherit"
                onClick={() => open ? setOpen(false) : setOpen(true)}
              >
                {open ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
            }
          </Box>
        </Toolbar>
      </AppBar>

      {(showSiteAndModule && isMobile) && (
        <Box sx={{ px: 1.5, py: 1, display: 'flex', flexDirection: 'column', gap: 1, bgcolor: 'white', boxShadow: '0px 2px 4px 0px #00000014' }}>
          <Box component="span" className={classes.labelNoto16Bold600} sx={{ backgroundColor: '#DCF8D8', color: '#424242', borderRadius: 2, px: 1, height: 30, display: 'inline-flex', alignItems: 'center', width: 'fit-content', maxWidth: '100%' }}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap' }}>{moduleName}</Typography>
          </Box>
          <Select
            sx={{
              height: 36,
              width: '100%',
              borderRadius: 2,
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#00AC4F',
                borderWidth: 2
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#00AC4F'
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#00AC4F'
              },
              '& .MuiSelect-select': {
                ...GenericConstant.DROPDOWNSTYLE,
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden'
              },
            }}
            IconComponent={KeyboardArrowDownOutlinedIcon}
            value={siteSelected ?? ''}
            onChange={(e) => setSelectedSite(e?.target?.value ?? '')}
          >
            {userOwnSites?.map((site: any) => (
              <MenuItem sx={{ ...GenericConstant.DROPDOWNSTYLE }} key={String(site?.full_code ?? '')} value={site?.full_code ?? ''}>
                {site?.site_name}-{site?.full_code}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}

      <DrawerMenu menuArr={menuListArr} open={open} handleDrawerClose={handleDrawerClose} position={"right"}  backGround={"#EEF8ED"}  backDrops={true}  variant={"temporary"} topZero={false} isCollapsible={false}   moduleName='post-season'/>
      { (moduleName=="In-season operations") && <DrawerMenu menuArr={[InSeasonModuleOptions]} open={collpase}  position={"left"}  backGround={"#FFFFFF"} backDrops={false}  variant={"permanent"} topZero={true} isCollapsible={true}  moduleName='in-season'/>}

    </>
  );
};
export default TopBar;

